<template>
  <van-popup v-model="isShow" position="bottom">
    <van-picker show-toolbar :columns="data" @change="onChange" value-key="label" @confirm="onConfirm" @cancel="onCancel" />
  </van-popup>
</template>
<script>
export default {
  name: 'MPicker',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  computed: {
    isShow: {
      get: function() {
        return this.show;
      },
      set: function(newValue) {
        this.$emit('cancel', newValue)
        return newValue;
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    onChange(picker, value, index) {
      console.log(value)
      this.$emit('change', value)
    },
    onConfirm(value, index) {
      this.$emit('confirm', value)
    },
    onCancel() {
      this.$emit('cancel', false)
    }
  }
}
</script>
<style lang="less" scoped>
@import '~style/var.less';
</style>



// WEBPACK FOOTER //
// src/components/MPicker.vue